<mat-dialog-content>
	@if (icon || title) {
	<div class="flex items-start gap-2.5 mb-2">
		@if (icon) {
		<div class="text-2xl flex items-center justify-center">
			<mat-icon class="mat-icon-inline">{{ icon }}</mat-icon>
		</div>
		} @if (title) {
		<h2 class="text-2xl font-bold">{{ title }}</h2>
		}
	</div>
	}
	<div class="mat-typrography">{{ message }}</div>
</mat-dialog-content>
<mat-dialog-actions align="end">
	<button
		[matDialogClose]="true"
		color="primary"
		mat-raised-button
	>
		{{ strings.confirm || 'utils.discard-change.ok' | translate }}
	</button>
	<button
		[matDialogClose]="false"
		mat-button
	>
		{{ strings.cancel || 'utils.discard-change.cancel' | translate }}
	</button>
</mat-dialog-actions>
